module.exports = __webpack_public_path__ + "static/media/descontos.6d904fb4.svg";